import React from 'react'
import '../SinglePage.scss'
import Text from './Text'

// FUNCTIONAL COMPONENT
const Terms = () => {
    return (
        <div className="single-page">
            <Text/>
        </div>
    )
}

export default Terms